import { render, staticRenderFns } from "./MapWidget.vue?vue&type=template&id=37159160&"
import script from "./MapWidget.vue?vue&type=script&lang=js&"
export * from "./MapWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37159160')) {
      api.createRecord('37159160', component.options)
    } else {
      api.reload('37159160', component.options)
    }
    module.hot.accept("./MapWidget.vue?vue&type=template&id=37159160&", function () {
      api.rerender('37159160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/MapWidget.vue"
export default component.exports